import { inputStringToDate } from "@/common/helpers/date-input";
import { formatDateToApi } from "@/common/helpers/format-date";
import { REQUIRES_DRIVER_STATUSES } from "@/modules/fit/internal/relocation-order/admin/_constants/relocation-order-statuses";
import { RelocationOrderAdminFormSchemaType } from "@/modules/fit/internal/relocation-order/admin/_components/relocation-order-admin-form-fields";

export function sanitizeRelocationOrderValues(values: RelocationOrderAdminFormSchemaType): Omit<
  RelocationOrderAdminFormSchemaType,
  "earliestPickupDate" | "pickedUpBy" | "orderedBy"
> & {
  earliestPickupDate: string;
  pickedUpBy?: string;
  orderedBy?: string | null;
} {
  const { pickedUpBy: initialPickedUpBy, orderedBy: initialOrderedBy, status, earliestPickupDate, ...rest } = values;

  let pickedUpBy = initialPickedUpBy;

  if (!REQUIRES_DRIVER_STATUSES.includes(status)) {
    pickedUpBy = null;
  }

  return {
    ...rest,
    status,
    pickedUpBy: pickedUpBy || undefined,
    orderedBy: initialOrderedBy,
    earliestPickupDate: formatDateToApi(inputStringToDate(earliestPickupDate)!),
  };
}
